import { type RefObject, useLayoutEffect, useState } from 'react';

import { AREA_SPECS } from '../dockview/area-specs';
import { railShowsTitle } from './rail-mode';

/** Whether the activityBar rail should paint icon + title. */
export function useRailExpanded(ref: RefObject<HTMLElement | null>): boolean {
  const [expanded, setExpanded] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    // Magnetic sizes belong to dockview's outer `.dv-view` (the slot is
    // narrower because the grid column has 3px horizontal padding).
    const railEl = el.closest('.dv-view');
    const widthEl = railEl instanceof HTMLElement ? railEl : el;
    const collapsed = AREA_SPECS.activityBar.minSize ?? 60;
    let previousWidth: number | undefined;
    const update = (): void => {
      const width = widthEl.getBoundingClientRect().width;
      if (previousWidth === width) {
        return;
      }
      setExpanded(railShowsTitle(width, collapsed, previousWidth));
      previousWidth = width;
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(widthEl);
    return () => observer.disconnect();
  }, [ref]);

  return expanded;
}
